
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "Page Not Found | DocketLabs";
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Page not found. Return to DocketLabs for AI legal consulting, strategy & training services. Find what you need here.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Page not found. Return to DocketLabs for AI legal consulting, strategy & training services. Find what you need here.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
